import { QuestionnaireTheme } from '../models/questionnaire';
import { hexToRgbA, invertHexColor } from './color';

export function toQuestionnaireElements(data: QuestionnaireTheme) {
  return {
    questionText: data.questionColor,
    helperText: hexToRgbA(data.questionColor || '#fff', 0.7),
    answerText: data.bodyColor,
    answerHelperText: data.bodyColor,
    productTitle: data.productColor,
    contactTitle: data.bodyColor,
    contactFormHeadings: data.bodyColor,
    contactFormHintText: hexToRgbA(data.bodyColor || '#fff', 0.7),
    productHighlightsText: data.bodyColor,
    productDescription: data.bodyColor,
    headerBar: data.topBarColor,
    logo: data.logoUrl,
    logoBackgroundColor: data.logoBackgroundColor,
    progressBar: data.buttonColor,
    background: data.backgroundColor,
    primaryButtonBackground: data.buttonColor,
    primaryButtonText: data.buttonTextColor,
    secondaryButtonBackground: invertHexColor(data.buttonColor || '#fff'),
    secondaryButtonText: invertHexColor(data.buttonTextColor || '#000'),
    linkText: data.buttonColor,
    priceText: data.productColor,
    recommendedBackground: data.recommendBackgroundColor,
    recommendedText: data.recommendTextColor,
    bulletPoints: data.recommendBackgroundColor,
    answerCardSelectedState: data.buttonColor,
    iconButtons: data.buttonColor,
    helperIconLink: data.iconButtonsColor,
    helperIcon: data.iconImageColor,
    websiteUrl: data.websiteUrl,
    bodyColor: data.bodyColor,
    iconColor: data.iconImageColor,
    fontTypeface: data.fontTypeface
  };
}
